// why pathway

import React from "react";
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../css/page.css';

function Page4() {

  const problems = [
    { problem: "Confused about which universities to apply to?", solution: "Pathway AI matches you with the best-fit colleges based on your profile." },
    { problem: "Struggling to write a standout resume?", solution: "Pathway AI's resume builder formats an optimal resume to present your strengths." },
    { problem: "Can't find relevant scholarships?", solution: "Pathway AI scans thousands of scholarships to find the right ones for you." },
    { problem: "Nervous about interviews?", solution: "Pathway AI's mock interviews give real-time feedback to improve your responses." },
    { problem: "Unable to produce an outstanding essay?", solution: "Pathway AI essay assistant helps you refine your ideas and enhance your writing." },
    { problem: "Lacking internship opportunities?", solution: "Pathway AI connects you to available oppportunities based on your skillsets." },
  ];

  return (
    <div className='ContentWrapper'>
      <Container style={{ maxWidth: '80%' }}>
        <Row>
          <h2 className='SubHeading' style={{ paddingTop: '2.5rem' }}>
            Why PathWay?
          </h2>
        </Row>
        <Row>
          <Container className="mt-5">
            <Row xs={1} md={2} className="g-4">
              {problems.map((item, index) => (
                <Col key={index}>
                  <Card className="h-100 shadow-sm p-3 glass-effect" style={{ textWrap: 'balance', borderRadius: '30px', background: 'rgba(251, 251, 251, 0.8)', backdropFilter: 'blur(10px)' }}>
                    <Card.Body>
                      <Card.Title>{item.problem}</Card.Title>
                      <Card.Text>{item.solution}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </Row>
      </Container>
    </div>
  );
}

export default Page4;

// TODO: Gap above too big